import { useActionState, useContext, useEffect, useOptimistic, useRef, useState, startTransition } from "react";

import axios from "axios";
import { motion } from 'framer-motion';

import AppContext from "../contexts/AppContext";
import CookieContext from "../contexts/CookieContext";

const Optimistic = () => {
  const { cookies } = useContext(CookieContext);
  const { apiHost, AppButton } = useContext(AppContext);
  const basePath = 'checklist/';

  const [error, setError] = useState();
  const inputRef = useRef(null);
  const [checklists, setChecklists] = useState([]);
  const [checklistsIsPending, setChecklistsIsPending] = useState([
    { id: 0, value: '000' },
    { id: 1, value: '111' },
    { id: 2, value: '222' },
    { id: 3, value: '333' },
    { id: 4, value: '444' },
    { id: 5, value: '555' },
    { id: 6, value: '666' },
    { id: 7, value: '777' },
    { id: 8, value: '888' },
    { id: 9, value: '999' },
  ]);

  const fetchChecklists = async (param) => {

    try {
      const headers = {
        'Content-Type': 'application/json',
        'Authorization': `JWT ${cookies.jwtAccess}`,
      };

      const response = await fetch(apiHost + basePath, {headers});

      if (response.status === 200) {
        const data = await response.json();
        setChecklists(data);
      }
      else if (response.status === 401) {
        setError('ログインしてください');
      }
      else {
        setError('エラー');
      }
    } catch (err) {
      console.log(err);
      setError('通信エラー');
    } finally {
    }
  }

  const [checklistName, formSubmitAction, isPending] = useActionState(async (prevState, formData) => {
    try {
      if (cookies.jwtAccess) {
        // jwtがある場合、headers（認証情報）有り
        const headers = {
          'Content-Type': 'application/json',
          'Authorization': `JWT ${cookies.jwtAccess}`,
        }

        const response = await axios.post(`${apiHost}${basePath}`, 
          {
            // name: formData.get('checklistName'),
            name: inputRef.current.value,
          },
          {headers},
        )

        if (response.status === 201) {
          // 更新した名前を返す
          return response.data.name
        } else if (response.status === 401) {
          setError('ログインしてください');
        } else {
          setError('エラー');
        }
      } else {
        setError('認証エラー');
      }
    } catch (err) {
      console.log(err);
      setError('通信エラー');
    } finally {
    }
  }, "");

  const [optimisticChecklists, addOptimisticChecklist] = useOptimistic(
    checklistsIsPending,
    (currentChecklistsIsPending, delta) => currentChecklistsIsPending + delta
    // (state, newChecklist) => {
    //   return state.map(checklist =>
    //     checklist.id === newChecklist.id
    //     ? { ...checklist, is_checked: !checklist.is_checked }
    //     : checklist
    //   );
    // }

    // (state, newChecklist) => {
    //   return state.map(checklist =>
    //     checklist.id === newChecklist.id
    //     ? 'oooooooooo'
    //     : 'xxxxxxxxxx'
    //   );
    // }

    // (state, newChecklist) => {
    //   return '----------'
    // }
  );

  const handleClick = async (checklistId, index)  => {

    // addOptimisticChecklist({...optimisticChecklists, id: 10, value: 'xxx'})
    // addOptimisticChecklist({id: 10, value: 'xxx'})
    addOptimisticChecklist();
    // UIが即座に更新される
    checklistsIsPending.map((checklistIsPending, checklistIsPendingIndex) => {
      if (checklistIsPendingIndex === index){
        return {...checklistsIsPending, id: index, value: '【更新中】' }
      } else {
        return checklistsIsPending
      }
        // setChecklistsIsPending([...checklistsIsPending, { id: index, value: '【更新中】' }])
        // alert(index + 'checklistIsPending.value:' + checklistIsPending.value)
        // alert(index + 'checklistIsPending.value:' + checklistIsPending.value)
      }
    )

    // alert(checklistsIsPending[index].value)
    alert(checklistsIsPending[checklistId].value)

    try {
      if (cookies.jwtAccess) {
        // jwtがある場合、headers（認証情報）有り
        const headers = {
          'Content-Type': 'application/json',
          'Authorization': `JWT ${cookies.jwtAccess}`,
        }

        const response = await axios.put(`${apiHost}${basePath}check/${checklistId}/`, 
          {
            // checklist.idをurlで指定して、is_checkedを反転させるだけなので、下記のような更新するパラメータは不要
            // is_checked: true
            // name: formData.get('checklistName'),
            // name: inputRef.current.value,
          },
          {headers},
        )

        // alert(response.data.name)
        // alert(response.data.is_checked)

        if (response.status === 200) {
          setChecklistsIsPending((prev) => prev + 'yyy')
          // fetchChecklists()
        } else if (response.status === 401) {
          setError('ログインしてください');
        } else {
          setError('エラー');
        }
      } else {
        setError('認証エラー');
      }
    } catch (err) {
      console.log(err);
      setError('通信エラー');
    } finally {
    }
  }

  // load時
  useEffect(() => {
    fetchChecklists();
  }, [checklistName]);

  // load時
  useEffect(() => {
    fetchChecklists();
  }, [checklistsIsPending]);

  return (
    <>
      {checklistsIsPending.map(aaa => (
        <li>{aaa.value}</li>
      ))}
      <form action={formSubmitAction}>
        <input style={{ margin: "5px", fontSize: 30, }} type="text" name="checklistName" placeholder="メッセージを入力" ref={inputRef} />

        <AppButton type="submit" style={{ margin: "5px", fontSize: 30}} disabled={isPending}>送信</AppButton>
        {/* 送信中の表示 */}
        {isPending && <>送信中...</>}
        {/* 更新完了時の表示 */}
        {!isPending && checklistName}
      </form>
      <motion.div
          initial={{ opacity: 0, color: '#ff0000' }}
          animate={{ opacity: 1, color: '#ff0000' }}
          transition={{ delay: 0, duration: 1, repeat: Infinity }}
        >
        {error}
      </motion.div>
      <div className="contents">
        <ul className="contents_ul">
          {optimisticChecklists.map((checklist, index) => (
            <li className="contents_li" key={checklist.id}>
              {checklist.checked_datetime}
              {/* <button onClick={() => handleClick(checklist.id, index)}> */}
              <button onClick={() => startTransition(() => handleClick(checklist.id, index))}>
                {checklist.is_checked ? '完了' : '未完了'}
              </button>
              ★{index}★
              [{checklist.id}]
              {checklist.name}
            </li>
          ))}
        </ul>
      </div>
    </>
  );
};
export default Optimistic